export default "//yastatic.net/s3/distribution/pythia/frontend/_/0d7d425ad74c5f8db2eba8e8e26f98c2.png";